import _classPrivateFieldInitSpec from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldGet from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
import "core-js/modules/esnext.iterator.map.js";
import JsonMappedModel from "../helpers/JsonMappedModel";
import ECommerceSdk from "@/assets/js/models/ECommerceSdk/ECommerceSdk";
import ECommerceSdkAccountFieldCollection from "@/assets/js/models/ECommerceSdk/ECommerceSdkAccountFieldCollection";
import User from "@/assets/js/models/user/User";
var _attribute = /*#__PURE__*/new WeakMap();
export default class ECommerceSdkAccount extends JsonMappedModel {
  constructor(data) {
    super(data);
    _classPrivateFieldInitSpec(this, _attribute, {
      [ECommerceSdkAccount.id_attribute_name]: null,
      [ECommerceSdkAccount.account_id_type_attribute_name]: null,
      [ECommerceSdkAccount.sdk_attribute_name]: ECommerceSdk,
      [ECommerceSdkAccount.account_owner_attribute_name]: User,
      [ECommerceSdkAccount.fields_attribute_name]: ECommerceSdkAccountFieldCollection,
      [ECommerceSdkAccount.status_attribute_name]: ECommerceSdkAccount.INACTIVE_STATUS
    });
    this.map(data, _classPrivateFieldGet(_attribute, this));
  }
  static getAccountIdType() {
    return ECommerceSdkAccount.account_id_type_attribute_name;
  }
  static getAccountOwnerAttributeName() {
    return ECommerceSdkAccount.account_owner_attribute_name;
  }
  static getSdkAttributeName() {
    return ECommerceSdkAccount.sdk_attribute_name;
  }
  static getFieldsAttributeName() {
    return ECommerceSdkAccount.fields_attribute_name;
  }
  static getStatusAttributeName() {
    return ECommerceSdkAccount.status_attribute_name;
  }
  getAccountOwner() {
    return this.getAttribute(ECommerceSdkAccount.account_owner_attribute_name);
  }
  getSdk() {
    return this.getAttribute(ECommerceSdkAccount.sdk_attribute_name);
  }
  getSdkName() {
    let sdk = this.getSdk();
    return sdk instanceof ECommerceSdk ? sdk.getName() : null;
  }
  getStatus() {
    return this.getAttribute(ECommerceSdkAccount.getStatusAttributeName());
  }
}
_defineProperty(ECommerceSdkAccount, "ACTIVE_STATUS", 'active');
_defineProperty(ECommerceSdkAccount, "INACTIVE_STATUS", 'inactive');
_defineProperty(ECommerceSdkAccount, "id_attribute_name", 'id');
_defineProperty(ECommerceSdkAccount, "account_id_type_attribute_name", 'account_id_type');
_defineProperty(ECommerceSdkAccount, "sdk_attribute_name", 'sdk');
_defineProperty(ECommerceSdkAccount, "account_owner_attribute_name", 'account_owner');
_defineProperty(ECommerceSdkAccount, "fields_attribute_name", 'fields');
_defineProperty(ECommerceSdkAccount, "status_attribute_name", 'status');